/**
 * useSeasonOverlays – React Query hooks for place_season_overlays.
 */
import { useQuery } from '@tanstack/react-query';
import { getOverlay, getOverlaysForPlace, type SeasonOverlay } from '@/lib/api/placeSeasonOverlays';
import type { Season } from '@/lib/season';

export function useSeasonOverlay(placeId: string | null | undefined, season: Season) {
  return useQuery<SeasonOverlay | null>({
    queryKey: ['season-overlay', placeId, season],
    queryFn: () => getOverlay(placeId!, season),
    enabled: !!placeId,
  });
}

export function useSeasonOverlays(placeId: string | null | undefined) {
  return useQuery<SeasonOverlay[]>({
    queryKey: ['season-overlays', placeId],
    queryFn: () => getOverlaysForPlace(placeId!),
    enabled: !!placeId,
  });
}
